import { useState } from 'react';
import { Link } from 'react-router-dom';
import { cn, FormatUtils, PermissionUtils, RoutePaths } from '@shared/utils';
import { AccountType, CardKind, type CardResponse } from '@shared/api';
import { DeleteConfirmationModal } from '../modals';
import { Button, Icon, Text } from '@shared/widgets';
import VisaIcon from '@assets/icons/card/visa.svg';
import MastercardIcon from '@assets/icons/card/mastercard.svg';
import TrashIcon from '@assets/icons/trash.svg';

export interface SmallCardProps {
  className?: string;
  card: CardResponse;
  onRemove: (id: number) => void;
}

export const SmallCard = (props: SmallCardProps) => {
  const [showDeleteConfirmationModal, setShowDeleteConfirmationModal] = useState<boolean>(false);

  return (
    <>
      <div className={cn('flex items-center justify-between gap-2 border-b border-b-gray-black pb-6', 'last:border-none last:pb-0', props.className)}>
        <Link className='flex items-center gap-2' to={RoutePaths.card.onNavigate(props.card.cardId)}>
          {props.card.cardKind === CardKind.Credit && (
            <Icon
              className='flex h-10 w-16 items-center justify-center rounded-lg bg-soft-black p-2 text-center dark:bg-gray-wet-asphalt'
              color='white'
              icon={<VisaIcon />}
            />
          )}
          {props.card.cardKind === CardKind.Debit && (
            <Icon
              className='flex h-10 w-16 items-center justify-center rounded-lg bg-soft-black p-2 text-center dark:bg-gray-wet-asphalt'
              icon={<MastercardIcon className='h-full w-full' />}
            />
          )}
          <Text className='flex-auto overflow-hidden text-ellipsis' weight='medium' size='xs' color='secondary' uppercase>
            {FormatUtils.toSliceNumber(props.card.cardNumber)}
          </Text>
        </Link>
        {PermissionUtils.manageCardsPermissions() && (
          <Button color='icon' onClick={() => setShowDeleteConfirmationModal(true)}>
            <Icon icon={<TrashIcon />} />
          </Button>
        )}
      </div>
      <DeleteConfirmationModal
        isOpen={showDeleteConfirmationModal}
        onClose={() => setShowDeleteConfirmationModal(false)}
        type={AccountType.Card}
        onDelete={() => props.onRemove(props.card.cardId)}
      />
    </>
  );
};
